<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <SelectDate
      v-model:selectDate="curClassDate"
      ref="selectDateRef"
    ></SelectDate>
    <div class="LineClassList">
      <div
        class="LineClassDayList"
        ref="wrapper"
        style="
          height: calc(100vh - 4rem);
          padding: 0 0.4rem;
          margin-bottom: 1.5rem;
        "
      >
        <div class="flex w-full bg-white items-center">
          <van-search
            class="flex-1"
            v-model="searchLine"
            placeholder="请输入线路名称"
          />
          <!-- <van-switch v-model="collapseModel" /> -->
          <van-switch
            v-model="collapseModel"
            size="24px"
            active-color="#1989fa"
          />
          <p class="mx-0.5">{{ collapseModel ? "全部展开" : "全部折叠" }}</p>
        </div>

        <van-tabs :active="openClassActiveName" @change="onOpenClassChange">
          <van-tab
            :title="'有开班'.concat('(', getLineCount(1), ')')"
            name="hasOpenClass"
          ></van-tab>
          <van-tab
            :title="'无开班'.concat('(', getLineCount(0), ')')"
            name="noOpenClass"
          ></van-tab>
        </van-tabs>

        <van-collapse v-model="activeNames">
          <van-collapse-item
            v-for="item of getTabLineList"
            :key="item.GID"
            :name="item.GID"
            class="lineSelect"
          >
            <template #title>
              <van-row>
                <van-col span="20">{{ item.LineName }}</van-col>
                <!-- <van-col span="4">{{ item.LineClassDayCount }}班</van-col> -->
                <van-col span="4"
                  >{{ getLineClassDayCount(item.LineGID) }}班</van-col
                >
              </van-row>
            </template>
            <van-collapse v-model="item.activeNames" accordion>
              <van-collapse-item
                :name="classDay.GID"
                :key="classDay.GID"
                v-for="classDay in getLineClassDayByLineGID(item.LineGID)"
                style="padding: 0rem"
              >
                <template #title>
                  <div style="text-align: left; color: black; font-weight: 900">
                    {{ classDay.ClassTime }}
                    <!-- 停售、停班标识 -->
                    <div
                      class="stopSale"
                      v-if="
                        classDay.ClassStatusID == 2 ||
                        classDay.ClassStatusID == 5
                      "
                    >
                      <span>停</span>
                    </div>
                    <!-- <span
                      v-if="classDay.ClassStatusID == 2"
                      style="color: red; font-size: 0.1rem"
                      >停</span
                    > -->
                  </div>
                </template>
                <template #value>
                  <div
                    style="color: black; font-weight: 900; text-align: right"
                  >
                    <!-- 总:{{ classDay.HandSellCount }} -->
                    <span
                      style="
                        color: black;
                        text-align: left;
                        margin-right: 0.5rem;
                        display: inline-block;
                        width: 1.3rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      >售:{{ classDay.SellCount }}</span
                    >
                    <span
                      style="
                        color: black;
                        text-align: left;
                        margin-right: 0.2rem;
                        display: inline-block;
                        width: 1.3rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      >余:{{ classDay.CanSellCount }}</span
                    >
                  </div>
                </template>
                <div class="LineClassDayList">
                  <div>
                    <div @click="lineClassListClick(classDay)" class="wrap">
                      <div v-cloak>
                        <span class="startCarTime">
                          时间：
                          <span>{{ classDay.sendCarTime }}</span>
                        </span>
                        <span>
                          座位数：
                          <span>{{ classDay.SeatCount }}&nbsp;</span>
                          <van-button
                            type="default"
                            size="mini"
                            color="#2891e7"
                            @click.stop="
                              showChangeSeat = true;
                              logSeat = classDay.SeatCount;
                              lineClassDay = classDay;
                            "
                            >修改</van-button
                          >
                        </span>
                      </div>
                      <div class="Node" v-if="IsShowLineNode">
                        <span class="">
                          班次途径点：
                          <span>{{ classDay.LineClassDayNode }}</span>
                        </span>
                      </div>
                      <!-- <div class="Node" v-else>
                        <span class="startNodeName">
                          始发站：
                          <span>{{ classDay.StratNodeName }}</span>
                        </span>
                        <span class="endNodeName">
                          终点站：
                          <span>{{ classDay.EndNodeName }}</span>
                        </span>
                      </div> -->

                      <!-- <div>
                        <span @click.stop>班次车辆信息:{{ classDay.VehicleStatus }}</span>
                      </div> -->
                      <div>
                        <span @click.stop="isDisplayVehicleClick(classDay)">
                          查看班次车辆详情：
                          <van-switch
                            style="z-index: 0; transform: translateY(0.1rem)"
                            v-model="classDay.vehicleChecked"
                            active-color="#2891e7"
                            size=".44rem"
                          />
                        </span>
                        <!-- <span class="state" @click.stop>
                          班次状态：
                          <span
                            :class="{
                              currentState: classDay.ClassStatusID == 2,
                            }"
                            >{{
                              classDay.ClassStatusID == 1 ? "售票" : "停售"
                            }}</span
                          >
                          <van-switch
                            style="
                                    z-index: 0;
                                    transform: translateY(0.1rem);
                                    margin-left: 8px;
                                  "
                            v-model="classDay.isSale"
                            size=".44rem"
                            active-color="#07c160"
                            inactive-color="#ee0a24"
                            @input="onChangeState(classDay, classDay.isSale)"
                          />
                        </span> -->
                        <div
                          class="flex-1 flex"
                          @click.stop="showStateChange(classDay)"
                        >
                          班次状态：
                          <div class="flex-1 text-center">
                            <span
                              class="underline"
                              :style="{
                                color: classStatusName(classDay).color,
                              }"
                              >{{ classStatusName(classDay).name }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        @click.stop
                        v-for="vehicleItem of classDay.VehicleArr"
                        :key="vehicleItem.id"
                        class="carList"
                      >
                        <span v-cloak v-if="classDay.vehicleChecked">
                          车牌号：{{ vehicleItem.VehicleNo }}
                          <span
                            @click.stop="signInDetails(classDay, vehicleItem)"
                            v-if="
                              !vehicleItem.CheckInTime &&
                              classDay.CustomMadeLevel != 3 &&
                              classDay.CustomMadeLevel != 4
                            "
                            >签到</span
                          >
                          <span
                            @click.stop="cancelSignIn(vehicleItem)"
                            v-if="
                              vehicleItem.CheckInTime &&
                              !vehicleItem.DepartTime &&
                              classDay.CustomMadeLevel != 3 &&
                              classDay.CustomMadeLevel != 4
                            "
                            >取消签到</span
                          >
                        </span>
                        <span v-cloak v-if="classDay.vehicleChecked"
                          >司机：{{ vehicleItem.Driver1Name }} &nbsp;&nbsp;{{
                            vehicleItem.Driver2Name
                          }}</span
                        >
                      </div>
                      <div
                        @click.stop
                        v-if="
                          classDay.VehicleArr.length == 0 &&
                          classDay.vehicleChecked
                        "
                      >
                        <span>暂无数据</span>
                      </div>
                      <div class="sale">
                        <span class="num">
                          已售：
                          <span>{{ classDay.SellCount }}</span>
                        </span>
                        <span class="price">
                          已售金额：
                          <span>{{ classDay.SellCountPrice }}</span>
                        </span>
                      </div>
                      <div class="sale">
                        <span class="num">
                          已订：
                          <span>{{ classDay.BookCount }}</span>
                        </span>
                        <span class="price">
                          已订金额：
                          <span>{{ classDay.BookCountPrice }}</span>
                        </span>
                      </div>
                      <div class="Node" v-if="IsShowDispatchRemark">
                        <span class="Remark">
                          调度备注：
                          <span>{{ classDay.Remark }}</span>
                        </span>
                      </div>
                      <div class="Node">
                        <span class="ClassTag">
                          班次标签：
                          <span>{{ classDay.ClassTag }}</span>
                        </span>
                      </div>
                      <div class="btnWrap">
                        <!-- <span @click.stop="isClassStatePopup(item)" class="classState">停售状态</span> -->
                        <span
                          @click.stop="copyClassBtnClick(classDay)"
                          class="copyClass"
                          >复制班次</span
                        >
                        <span
                          @click.stop="modifyClassBtnClick(classDay)"
                          class="modifyClass"
                          >修改班次</span
                        >
                        <span
                          @click.stop="modifyClassPriceBtnClick(classDay)"
                          class="modifyClass"
                          >修改票价</span
                        >
                        <span
                          @click.stop="sendCarAndSignIn(classDay)"
                          class="sendCarAndSignIn"
                          >派车</span
                        >
                        <span
                          @click.stop="editSeatChart(classDay)"
                          class="editSeatChart"
                          >修改座位图</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </van-collapse-item>
        </van-collapse>
      </div>

      <!-- <div style="font-size: 0.44rem">暂无数据</div> -->

      <footer>
        <div
          @click="lineBtnClick"
          :class="{ current: this.selectedSearchState }"
        >
          {{ selectedSearchLine }}
        </div>
        <div
          @click="carBtnClick"
          :class="{ current: this.selectedSearchCarState }"
        >
          {{ selectedSearchCar }}
        </div>
        <div
          @click="departBtnClick"
          :class="{ current: this.selectedSearchDepartState }"
        >
          {{ selectedSearchDepart }}
        </div>
      </footer>

      <!-- 复制班次 -->
      <van-popup class="isCopyClass" v-model="isCopyClass" position="center">
        <div class="header">复制班次</div>
        <div>
          <span>班次日期：</span>
          <span @click="copyClassDayBtnClick">
            <input v-model="copyClassDay" type="text" />
          </span>
        </div>
        <div>
          <span>班次时间：</span>
          <span>
            <input v-model="copyClassTime" type="text" />
          </span>
        </div>
        <div class="btnWrap">
          <span @click="confirmCopyClass">确定</span>
          <span @click="cancelCopyClass">取消</span>
        </div>
      </van-popup>

      <!-- 复制班次日期 -->
      <van-popup v-model="isSelectCopyClassDay" position="bottom">
        <van-datetime-picker
          @confirm="CopyClassDayDatePickerConfirm"
          @cancel="CopyClassDayDatePickerCancel"
          v-model="copyDateTime"
          type="date"
        />
      </van-popup>

      <!-- 修改班次 -->
      <van-popup
        class="isModifyClass"
        v-model="isModifyClass"
        position="center"
      >
        <div class="header">修改班次</div>
        <div class="wrap">
          <div>
            <span>线路：</span>
            <span>
              <input disabled type="text" v-model="curModifyItem.LineName" />
            </span>
          </div>
          <div>
            <span>班次号：</span>
            <span>
              <input disabled type="text" v-model="curModifyItem.ClassCode" />
            </span>
          </div>
          <div>
            <span>班次日期：</span>
            <span v-if="curModifyItem.ClassDate">
              <input
                disabled
                type="text"
                v-model="curModifyItem.ClassDate.split(' ')[0]"
              />
            </span>
          </div>
          <div>
            <span>座位数：</span>
            <span>
              <input type="text" disabled v-model="curModifyItem.SeatCount" />
            </span>
          </div>
          <div>
            <span>优惠票数：</span>
            <span>
              <input type="text" v-model="curModifyItem.OfferRemainingSeats" />
            </span>
          </div>
          <div>
            <span>承运单位：</span>
            <span>
              <input type="text" v-model="curModifyItem.CarrierCompName" />
            </span>
          </div>
          <div>
            <span>始发时间：</span>
            <span>
              <input type="text" v-model="curModifyItem.ClassTime" />
            </span>
          </div>
          <div>
            <span>免票儿童数：</span>
            <span>
              <input type="text" v-model="curModifyItem.FreeChildCount" />
            </span>
          </div>
          <div>
            <span>随车电话：</span>
            <span>
              <input type="text" v-model="curModifyItem.FollowTel" />
            </span>
          </div>
          <div v-if="IsShowDispatchRemark">
            <span>调度备注：</span>
            <span>
              <input type="text" v-model="curModifyItem.Remark" />
            </span>
          </div>
          <div>
            <span>班次标签：</span>
            <span>
              <input type="text" v-model="curModifyItem.ClassTag" />
            </span>
          </div>
        </div>
        <div class="btnWrap">
          <div @click="modifyClassConfirmBtnClick">确定</div>
          <div @click="modifyClassCalcelBtnClick">取消</div>
        </div>
      </van-popup>

      <!-- 派车签到 -->
      <van-popup
        class="isSendCarAndSignIn"
        v-model="isSendCarAndSignIn"
        position="bottom"
      >
        <div>
          <span @click="sendCarDetails">派车</span>
          <span @click="signInDetails">签到</span>
          <span>发车</span>
        </div>
      </van-popup>

      <!-- 线路 -->
      <van-popup
        class="lineSelectListPopup"
        v-model="lineSelectListShow"
        position="bottom"
      >
        <div
          @click="lineSelectClick(item, index)"
          class="single-line-ellipsis"
          v-for="(item, index) of lineSelectList"
          :key="item.id"
          :class="{ current: item.selectState }"
        >
        {{ item.LineName }}
        </div>
      </van-popup>

      <!-- 机构 -->
      <van-popup
        class="lineSelectListPopup"
        v-model="carSelectListShow"
        position="bottom"
      >
        <div
          @click="carSelectClick(item, index)"
          class="lineSelectList"
          v-for="(item, index) of OrganizationList"
          :key="item.id"
          :class="{ current: item.selectState }"
        >
          {{ item.PathName }}
        </div>
      </van-popup>

      <!-- 是否发车 -->
      <van-popup
        class="lineSelectListPopup"
        v-model="departSelectListShow"
        position="bottom"
      >
        <div
          @click="departSelectClick(item, index)"
          class="lineSelectList"
          v-for="(item, index) of departStateList"
          :key="item.id"
          :class="{ current: item.selectState }"
        >
          {{ item.text }}
        </div>
      </van-popup>

      <van-dialog
        v-model="showChangeSeat"
        title="请输入班线座位数量:"
        show-cancel-button
        v-on:confirm="onChangeSeat"
        v-on:cancel="closeChangeDialog"
        :before-close="onChangeSeatBeforeClose"
      >
        <van-stepper v-model="logSeat" integer min="1" max="1999" />
        <!-- <van-field
          v-model="logSeat"
          label="最大可售数:"
          placeholder="请输入班次最大可售数"
          type="number"
          clearable
          border
        />-->
      </van-dialog>

      <van-action-sheet
        v-model="stateChangeShow"
        :actions="[
          { name: '停班', status: 5, color: '#ee0a24' },
          { name: '停售', status: 2, color: '#7f1f1f' },
          { name: '售票', status: 1, color: '#07c160' },
        ]"
        cancel-text="取消"
        close-on-click-action
        @select="onStateChangeSelect"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import SelectDate from "../../components/selectDate.vue";
import dateCalendarStore from "../../stores/dateCalendarStore";

//import Bscroll from "better-scroll";
export default {
  components: {
    Header,
    SelectDate,
  },
  data() {
    return {
      isCanManage: false, //是否允许在移动端操作
      title: "班线管理", //标题
      logSeat: null, //班次座位数记录
      lineClassDay: null, //当前选中的班次
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID, // 公司GID
      curClassDate: dateCalendarStore.state.selectDate || new Date(), // 查询时间
      dataCompleteState: false, // 数据获取的状态
      lineClassList: [], // 线路列表
      orgLineClassList: [],
      lineSelectListShow: false, // 线路弹出层
      lineSelectList: [], // 线路选择的数组
      selectedSearchLine: "线路", // 被选中查询的线路
      selectedSearchState: false, // 用于判断线路样式
      LineGIDList: "", // 用于查询线路的线路GID
      OrganizationList: [], // 机构信息列表
      carSelectListShow: false, // 车辆信息弹出层
      selectedSearchCar: "机构", // 被选中查询的 -- 机构
      selectedSearchCarState: false, // 用于判断车辆样式
      departSelectListShow: false, // 是否发车弹出层
      departStateList: [
        { text: "未发车", selectState: false },
        { text: "已发车", selectState: false },
      ],
      selectedSearchDepart: "是否发车", // 被选中查询的 -- 机构
      selectedSearchDepartState: false, // 用于判断是否发车样式
      OrganizationGID: "", // 车辆 -- 机构GID
      classState: false, // 班次状态弹窗
      classStateID: "", // 班次状态ID 1为售票 2为停售
      selectedClassItem: [], // 当前选中项
      isCopyClass: false, // 复制班次弹窗显示状态
      currentSelectedClass: [], // 当前选中班次
      copyClassDay: "", // 复制班次日期
      prevCopyClassDay: "", // 复制班次日期 上一下次选择的日期
      originCopyClassDay: "", // 初始的班次日期
      copyClassTime: "", // 复制班次时间
      originCopyClassTime: "", //初始的班次时间
      isSelectCopyClassDay: false, // 选择复制班次时间弹出层
      copyDateTime: "", //复制班次时间弹出层的时间
      isModifyClass: false, // 修改班次弹窗显示状态
      curModifyItem: [], // 当前选中的 -- 修改班次数组
      originCurModifyItem: [], // 初始的当前选中的 -- 修改班次数组
      isSendCarAndSignIn: false, // 派车签到弹窗显示状态
      isSendCar: false, // 派车弹窗显示状态
      isSignIn: false, //签到弹窗显示状态
      choiceSendCar: null, //被选中派车签到的线路
      signInCarArr: [], //签到的车辆列表
      showChangeSeat: false, //是否显示修改座位数
      carArr: [
        {
          CompVehicleArr: [], // 车辆列表
          isCompCarNo: false, // 是否显示公司车辆 选择弹出框
          tempCarNo: "", // 默认的车牌号码
          tempCheck: "", // 校验
          tempCheckFlag: false, //是否通过校验
          Qualifications: null, //车辆资质
          CompDriverArr: [], // 司机名称列表
          tempCarDriver1: "", // 默认的司机名称
          tempCarTel1: "", // 默认的司机电话
          tempCarDriver1ID: null, // 默认的司机GID
          isCompDriver1: false, // 是否显示公司司机 选择弹出框
          tempCarDriver2: "", // 默认的副司机名称
          tempCarTel2: "", // 默认的副司机电话
          tempCarDriver2ID: null, // 默认的副司机GID
          isCompDriver2: false, // 是否显示公司副司机 选择弹出框
          VehicleGID: "", // 车辆的GID
        },
      ], // 车辆数组
      active: 0,
      isClose: true,
      IsShowLineNode: false, // 是否展示班线途径点
      IsShowDispatchRemark: false, // 是否显示调度备注
      activeNames: [],

      openClassActiveName: "hasOpenClass", // 选中是否开班
      scrollTop: 0, // 记录离开页面时滚动条位置
      isRefresh: false, // 是否刷新数据
      searchLine: "", // 线路名称搜索

      collapseModel: false,
      stateChangeShow: false, // 是否显示切换班次状态
      currentLineClassDay: {}, // 操作班次状态的班次

      reloadSelectDate: 1,
    };
  },
  computed: {
    classStatusName() {
      return function (item) {
        let o = {};
        switch (item.ClassStatusID) {
          case 1:
            o.name = "售票";
            o.color = "#07c160";
            break;
          case 2:
            o.name = "停售";
            o.color = "#7f1f1f";
            break;
          case 3:
            o.name = "签到";
            break;
          case 4:
            o.name = "发车";
            break;
          case 5:
            o.name = "停班";
            o.color = "#ee0a24";
            break;
        }
        return o;
      };
    },
    /**
     * 线路列表
     */
    getLineSelectList() {
      let lineList = this.lineSelectList;
      let lineGIDList = this.LineGIDList.split(",");
      // 过滤出已选择的线路
      if (this.LineGIDList && lineGIDList.length > 0) {
        lineList = lineList.filter((l) => {
          return lineGIDList.indexOf(l.LineGID) > -1;
        });
      }
      // 过滤线路名称
      if (this.searchLine) {
        lineList = lineList.filter((l) => {
          return l.LineName.indexOf(this.searchLine) > -1;
        });
      }
      // 过滤出机构线路
      if (this.OrganizationGID) {
        lineList = lineList.filter((l) => {
          if (l.OrganizationGIDList) {
            return (
              l.OrganizationGIDList.split(",").indexOf(this.OrganizationGID) >
              -1
            );
          }
          return false;
        });
      }
      // 过滤出已发车/未发车的线路
      if (this.selectedSearchDepart !== "是否发车") {
        let departLineGIDList = this.lineClassList
          .filter((lc) => {
            if (this.selectedSearchDepart === "已发车") {
              return lc.DepartCount > 0;
            } else if (this.selectedSearchDepart === "未发车") {
              return lc.DepartCount == 0;
            }
            return false;
          })
          .map((lc) => lc.LineGID);
        lineList = lineList.filter((l) => {
          return departLineGIDList.indexOf(l.LineGID) > -1;
        });
      }
      return lineList;
    },
    /**
     * 根据选择有无开班获取线路列表
     */
    getTabLineList() {
      let lineList = this.getLineSelectList;
      // 过滤出有无开班的线路
      lineList = lineList
        .filter((l) => {
          let index = this.lineClassList.findIndex(
            (c) => c.LineGID == l.LineGID
          );
          if (this.openClassActiveName == "hasOpenClass") {
            return index > -1;
          }
          return index == -1;
        })
        .sort((a, b) => {
          // 未设置线路序号为正无穷大
          return (
            (a.OrderByNo || Number.POSITIVE_INFINITY) -
            (b.OrderByNo || Number.POSITIVE_INFINITY)
          );
        });
      return lineList;
    },
    /**
     * 班次数
     */
    getLineClassDayCount() {
      return (lineGID) => {
        return this.lineClassList.filter((l) => l.LineGID == lineGID).length;
      };
    },
    getLineCount() {
      return (status) => {
        // status：0 - 无开班，1 - 有开班
        let lineList = this.getLineSelectList;
        return lineList.filter((l) => {
          let index = this.lineClassList.findIndex(
            (c) => c.LineGID == l.LineGID
          );
          if (status == 1) {
            return index > -1;
          }
          return index == -1;
        }).length;
      };
    },
  },
  methods: {
    //获取当前线路班次
    getLineClassDayByLineGID(lineGID) {
      var result = [];
      this.lineClassList.forEach((item) => {
        if (item.LineGID == lineGID) {
          result.push(item);
        }
      });
      return result;
    },
    //  关闭修改座位数弹窗
    closeChangeDialog() {
      this.showChangeSeat = false;
      //this.logSeat = null;
      this.lineClassDay = null;
    },
    //确认修改座位数
    onChangeSeat() {
      if (!this.lineClassDay) {
        this.$toast("未选中班次");
        this.closeChangeDialog();
        return;
      }
      if (this.logSeat < 1 || this.logSeat > 2000) {
        this.$toast("不允许输入小于1或大于2000的值");
        this.isClose = false;
        return;
      }
      let params = {
        ClassGID: this.lineClassDay.GID,
        OldSeatCount: this.lineClassDay.SeatCount,
        NewSeatCount: this.logSeat,
        ModifyGID: this.OperObj.GID, //操作员GID
        ModifyCode: this.OperObj.UserCode, //操作员代码
        ModifyName: this.OperObj.UserName, //操作员名称
      };
      this.$http
        .post(this.$api.lineClassSeatMapModify, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.$toast("修改座位数成功");
            this.lineClassDay.SeatCount = this.logSeat;
            this.closeChangeDialog();
          }
        });
    },
    //修改座位数弹窗关闭前
    onChangeSeatBeforeClose(action, done) {
      if (action === "confirm") {
        if (this.isClose) {
          done(false);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    //修改班次状态确认
    onChangeState(item, checked) {
      let info = checked ? "售票" : "停售";
      this.$dialog
        .confirm({
          title: "提醒",
          message: "是否修改班次状态为" + info + "？",
        })
        .then(() => {
          this.changeClassStateBtnClick(item, checked ? 1 : 2);
        });
    },
    // 获取实时班次
    getLineClassDay() {
      let params = {
        OrganizationGID: this.OrganizationGID
          ? this.OrganizationGID
          : JSON.parse(window.localStorage.getItem("adminInfo"))
              .OrganizationGID,
        LineGIDList: this.LineGIDList,
        BeginDate: this.$moment(this.curClassDate).format("YYYY-MM-DD"),
        EndDate: this.$moment(this.curClassDate).format("YYYY-MM-DD"),
        OperGID: this.OperObj.GID, //操作员GID
        CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        IsShowLineNode: this.IsShowLineNode,
      };
      this.dataCompleteState = false;
      this.$http
        .post(this.$api.getLineClassDay, this.$qs.stringify(params))
        .then((res) => {
          // console.log(res);
          if (res.success) {
            this.collapseModel = false;
            this.orgLineClassList = [...res.data];
            this.orgLineClassList.forEach((item) => {
              item.sendCarTime = item.ClassDate.slice(0, 11) + item.ClassTime;
              item.vehicleChecked = false;
              item.VehicleArr = [];
              item.isSale = item.ClassStatusID == 1;
              item.activeNames = [];
            });
            this.lineClassList = this.orgLineClassList;
            this.dataCompleteState = true;
          }
          // console.log(this.lineClassList)
        })
        .catch((err) => {
          this.collapseModel = false;
          console.log(err);
        });
    },
    // 获取机构信息
    getOrganization() {
      let params = {
        OrganizationGID: JSON.parse(window.localStorage.getItem("adminInfo"))
          .OrganizationGID,
      };
      this.$http
        .post(this.$api.getOrganization, this.$qs.stringify(params))
        .then((res) => {
          // console.log(res);
          if (res.success) {
            this.OrganizationList = res.data;
            this.OrganizationList.forEach((item) => {
              item.selectState = false;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取班次司机
    getVehicleDriver(item) {
      let params = {
        LineClassDayGID: item.GID,
      };
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then((res) => {
          // console.log(res);
          if (res.success) {
            if (res.data.length > 0) {
              item.VehicleArr = res.data;
              // this.lineClassList[index].VehicleArr = res.data;
              // this.$set(this.lineClassList[index], "VehicleArr", []);
              // this.$set(this.lineClassList[index], "VehicleArr", res.data);
            }

            // 这一步操作是让 switch 按钮渲染生效
            let list = this.lineClassList;
            this.lineClassList = [];
            this.lineClassList = list;
          }
        });
    },
    // 点击是否显示班次司机与车辆信息
    isDisplayVehicleClick(item) {
      //只有打开详情开关才查询
      if (item.vehicleChecked) {
        this.getVehicleDriver(item);
      } else {
        // 这一步操作是让 switch 按钮渲染生效
        let list = this.lineClassList;
        this.lineClassList = [];
        this.lineClassList = list;
      }
    },
    // 获取公司线路
    getCompLine() {
      let params = {
        OrganizationGID: JSON.parse(window.localStorage.getItem("adminInfo"))
          .OrganizationGID,
        QueryDate: this.$moment(this.curClassDate).format("YYYY-MM-DD"),
      };
      this.$http
        .post(this.$api.getGetCompLine, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            // 获取线路展开过的班次
            let hasActiveList = [];
            if (this.lineSelectList && this.lineSelectList.length > 0) {
              hasActiveList = this.lineSelectList.filter((l) => {
                return l.activeNames;
              });
            }
            res.data.forEach((item) => {
              item.selectState = false;
              let activeIndex = hasActiveList.findIndex((h) => {
                return h.GID == item.GID;
              });
              if (activeIndex > -1) {
                item.activeNames = hasActiveList[activeIndex].activeNames;
              }
              // item.activeNames = []
            });
            this.lineSelectList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 线路按钮点击事件
    lineBtnClick() {
      this.lineSelectListShow = true;
    },
    // 车辆按钮点击事件
    carBtnClick() {
      this.carSelectListShow = true;
    },
    // 是否发车按钮点击事件
    departBtnClick() {
      this.departSelectListShow = true;
    },
    // 修改班次 -- 状态
    changeClassStateBtnClick(item, ClassStatusID) {
      var _jsonText = {};
      _jsonText.GIDList = item.GID;
      _jsonText.ClassStatusID = ClassStatusID;
      _jsonText._CompGID = this.CompGID;
      _jsonText.ModifyGID = this.OperObj.GID; //操作员GID
      _jsonText.ModifyCode = this.OperObj.UserCode; //操作员代码
      _jsonText.ModifyName = this.OperObj.UserName; //操作员名称
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      this.$http
        .post(this.$api.editLineClassDayStatus, this.$qs.stringify(params))
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$toast("修改成功");
            //修改成功不再请求 修改本地状态
            item.isSale = ClassStatusID == 1;
            item.ClassStatusID = ClassStatusID;
            //this.getLineClassDay();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 确认修改班次 -- 内容
    modifyClassConfirmBtnClick() {
      if (
        this.curModifyItem.FollowTel.length > 0 &&
        this.curModifyItem.FollowTel.length !== 11
      ) {
        this.$toast("请输入正确的11位电话号码");
        return false;
      }
      var _jsonText = this.curModifyItem;
      // _jsonText.GID = this.curModifyItem.GID;
      // _jsonText.LineGID = this.curModifyItem.LineGID;
      // _jsonText.OfferRemainingSeats = this.curModifyItem.OfferRemainingSeats;
      //_jsonText.SeatCount = this.curModifyItem.SeatCount;
      // _jsonText.CarrierCompGID = this.curModifyItem.CarrierCompGID;
      // _jsonText.ClassTime = this.curModifyItem.ClassTime;
      // _jsonText.FreeChildCount = this.curModifyItem.FreeChildCount;
      // _jsonText.FollowTel = this.curModifyItem.FollowTel;
      // _jsonText.Remark = this.curModifyItem.Remark;
      _jsonText._CompGID = this.CompGID;
      _jsonText.ModifyGID = this.OperObj.GID; //操作员GID
      _jsonText.ModifyCode = this.OperObj.UserCode; //操作员代码
      _jsonText.ModifyName = this.OperObj.UserName; //操作员名称
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      this.$http
        .post(this.$api.editLineClassDay, this.$qs.stringify(params))
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$toast("修改成功");
            this.isModifyClass = false;
            this.getLineClassDay();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取消修改班次 -- 内容
    modifyClassCalcelBtnClick() {
      this.isModifyClass = false;
      this.curModifyItem = this.originCurModifyItem;
    },
    // 复制班次点击事件
    copyClassBtnClick(item) {
      this.currentSelectedClass = item;
      this.isCopyClass = true;
      this.copyClassDay = this.currentSelectedClass.ClassDate.split(" ")[0];
      this.copyClassTime = this.currentSelectedClass.ClassTime;
      this.originCopyClassDay =
        this.currentSelectedClass.ClassDate.split(" ")[0];
      this.originCopyClassTime = this.currentSelectedClass.ClassTime;
    },
    // 复制班次 -- 确定
    confirmCopyClass() {
      var _jsonText = {};
      _jsonText.GID = this.currentSelectedClass.GID;
      _jsonText.ClassDate = this.copyClassDay;
      _jsonText.ClassTime = this.copyClassTime;
      _jsonText._CompGID = this.CompGID;
      _jsonText.ModifyGID = this.OperObj.GID; //操作员GID
      _jsonText.ModifyCode = this.OperObj.UserCode; //操作员代码
      _jsonText.ModifyName = this.OperObj.UserName; //操作员名称
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      this.$http
        .post(this.$api.LineClassDayCopy, this.$qs.stringify(params))
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.isCopyClass = false;
            this.$toast("复制班次成功");
            this.getLineClassDay();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 复制班次 -- 取消
    cancelCopyClass() {
      this.isCopyClass = false;
      this.CopyClassDay = this.originCopyClassDay;
      this.copyClassTime = this.originCopyClassTime;
    },
    // 复制班次弹出层日期选择
    copyClassDayBtnClick() {
      this.isSelectCopyClassDay = true;
      this.copyDateTime = new Date(this.copyClassDay);
    },
    // 复制班次弹出层日期选择 -- 确认选择的日期
    CopyClassDayDatePickerConfirm() {
      this.isSelectCopyClassDay = false;
    },
    // 复制班次弹出层日期选择 -- 取消选择的日期
    CopyClassDayDatePickerCancel() {
      this.copyClassDay = this.prevCopyClassDay;
      this.copyDateTime = this.prevCopyClassDay;
      this.isSelectCopyClassDay = false;
    },
    //修改班次票价
    modifyClassPriceBtnClick(item) {
      this.$router.currentRoute.meta.keepAlive = true;
      this.$router.push({
        path: "LineClassDayPrice",
        query: {
          LineClassDayGID: item.GID,
          LineGID: item.LineGID,
          LineName: item.LineName,
          ClassTime: item.ClassTime,
        },
      });
    },
    // 修改班次点击事件
    modifyClassBtnClick(item) {
      this.isModifyClass = true;
      this.curModifyItem = JSON.parse(JSON.stringify(item));
      this.originCurModifyItem = JSON.parse(JSON.stringify(item));
      //console.log(this.curModifyItem)
    },
    // 点击修改座位图
    editSeatChart(item) {
      let localData = {
        GID: item.GID,
        LineClassName: item.LineName,
        ClassTime: item.ClassTime,
      };
      window.localStorage.setItem(
        "LineEditSeatInfo",
        JSON.stringify(localData)
      );
      this.$router.push({
        path: "LineClassEditSeatChart",
      });
    },
    // 派车签到点击事件
    sendCarAndSignIn(item) {
      this.choiceSendCar = item;
      //this.isSendCarAndSignIn = true;
      this.sendCarDetails();
    },

    // 派车跳转
    sendCarDetails() {
      //this.isSendCar = true;
      //this.isSendCarAndSignIn = false;
      //this.onCompVehicleQuery();
      //this.onCompDriverQuery();
      if (!window.framework && !this.isCanManage) {
        this.$toast("请在手持机上操作该功能!");
        return;
      }
      var tempLine = null;
      for (var i = 0; i < this.lineSelectList.length; i++) {
        if (this.lineSelectList[i].LineGID == this.choiceSendCar.LineGID) {
          tempLine = this.lineSelectList[i];
          break;
        }
      }
      var line = {
        text: tempLine.LineName,
        lineGID: tempLine.LineGID,
        lineInfo: tempLine,
        index: 0,
        children: [],
      };
      window.localStorage.setItem("line", JSON.stringify(line));
      window.localStorage.setItem(
        "lineClassDay",
        JSON.stringify(this.choiceSendCar)
      );
      this.$router.push({
        path: "LineClassDayVehicleDriver",
        query: {
          IsCheck: "DispatchingCar",
          GID: null,
        },
      });
    },
    // 设置本地缓存line
    setStorageLine(item) {
      this.choiceSendCar = item;
      var tempLine = null;
      for (var i = 0; i < this.lineSelectList.length; i++) {
        if (this.lineSelectList[i].LineGID == this.choiceSendCar.LineGID) {
          tempLine = this.lineSelectList[i];
          break;
        }
      }
      var line = {
        text: tempLine.LineName,
        lineGID: tempLine.LineGID,
        lineInfo: tempLine,
        index: 0,
        children: [],
      };
      window.localStorage.setItem("line", JSON.stringify(line));
      window.localStorage.setItem(
        "lineClassDay",
        JSON.stringify(this.choiceSendCar)
      );
    },
    // 签到按钮点击事件
    signInDetails(item, vItem) {
      if (!window.framework && !this.isCanManage) {
        this.$toast("请在手持机上操作该功能!");
        return;
      }
      this.setStorageLine(item);
      this.$router.push({
        path: "LineClassDayVehicleDriver",
        query: {
          IsCheck: "SignIn",
          GID: vItem.GID,
        },
      });
    },
    // 取消签到
    cancelSignIn(Vehicle) {
      this.$dialog
        .confirm({
          message: "确定要对车辆" + Vehicle.VehicleNo + "取消签到吗？",
        })
        .then(() => {
          if (Vehicle.DepartTime != null) {
            this.$toast.fail("已经发车车辆不能修改");
            return;
          }
          Vehicle.CheckInTime = null;
          Vehicle.CheckInOperGID = null;
          Vehicle.VehicleCheckInGeocoder = null;
          Vehicle.GPSErrorMsg = null;
          Vehicle.CheckImgPath = null;
          Vehicle.CheckResult = [];
          Vehicle.ModifyGID = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).GID;
          Vehicle.ModifyCode = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserCode;
          Vehicle.ModifyName = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserName;
          let params = {
            _JsonText: JSON.stringify(Vehicle),
          };
          this.$http
            .post(
              this.$api.onLineClassDayVehicleDriverCancelSign,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                this.$toast.success("车辆取消签到成功");
                //this.$router.go(-1);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 增加派车
    addSendCarPopup() {
      this.onCompVehicleQuery();
      this.onCompDriverQuery();
      this.carArr.push({
        CompVehicleArr: [], // 车辆列表
        isCompCarNo: false, // 是否显示公司车辆 选择弹出框
        tempCarNo: "", // 默认的车牌号码
        tempCheck: "", // 校验
        tempCheckFlag: false, //是否通过校验
        Qualifications: null, //车辆资质
        CompDriverArr: [], // 司机名称列表
        tempCarDriver1: "", // 默认的司机名称
        tempCarTel1: "", // 默认的司机电话
        tempCarDriver1ID: null, // 默认的司机GID
        isCompDriver1: false, // 是否显示公司司机 选择弹出框
        tempCarDriver2: "", // 默认的副司机名称
        tempCarTel2: "", // 默认的副司机电话
        tempCarDriver2ID: null, // 默认的副司机GID
        isCompDriver2: false, // 是否显示公司副司机 选择弹出框
        VehicleGID: "", // 车辆的GID
      });
    },
    // 保存派车
    saveSendCarPopup() {
      //console.log(this.carArr)
      var obj = this.carArr;
      var VehicleDriverJson = [];
      var VehicleNoList = [];
      for (var z = 0; z < obj.length; z++) {
        var i = obj[z];
        var x = z + 1;
        if (i.VehicleGID == "") {
          this.$toast("第" + x + "辆车未选择车辆！");
          return;
        }
        if (i.tempCarDriver1ID == "" || i.tempCarDriver1ID == null) {
          this.$toast("第" + x + "辆车未选择主司机！");
          return;
        } else if (i.tempCarDriver1ID == i.tempCarDriver2ID) {
          this.$toast("第" + x + "辆车选择的主、副司机为同一人，请重新选择");
          return;
        }
        if (!i.tempCheckFlag) {
          this.$toast("第" + x + "辆车选择的车辆未通过校验");
          return;
        }

        VehicleDriverJson.push({
          GID: null,
          VehicleGID: i.VehicleGID,
          Driver1GID: i.tempCarDriver1ID,
          Driver2GID: i.tempCarDriver2ID,
          Qualifications: i.Qualifications,
        });
        VehicleNoList.push(i.tempCarNo);
      }
      let params = {
        LineClassDayGID: this.choiceSendCar.GID,
        VehicleDriverJson: JSON.stringify(VehicleDriverJson),
        LineClassDayState: 0, //1是签到，0是派车
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode,
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName,
      };
      //console.log(params)
      //return
      this.$http
        .post(this.$api.onLineClassDayVehicleDriverBatchSave, {
          model: params,
          isMobile: false, //签到为true
        })
        .then((res) => {
          if (res.success) {
            let msg = "";
            msg = "派车成功!";
            if (res.data[0].datamsg) {
              this.$dialog.alert({
                message: msg + " 注意:" + res.data[0].datamsg,
              });
            } else {
              this.$toast.success(msg);
            }
            this.closeSendCarPopup();
          }
        });
    },
    // 关闭派车弹出层点击事件
    closeSendCarPopup() {
      this.isSendCar = false;
      this.carArr = [];
      this.carArr.push({
        CompVehicleArr: [], // 车辆列表
        isCompCarNo: false, // 是否显示公司车辆 选择弹出框
        tempCarNo: "", // 默认的车牌号码
        tempCheck: "", // 校验
        tempCheckFlag: false, //是否通过校验
        Qualifications: null, //车辆资质
        CompDriverArr: [], // 司机名称列表
        tempCarDriver1: "", // 默认的司机名称
        tempCarTel1: "", // 默认的司机电话
        tempCarDriver1ID: null, // 默认的司机GID
        isCompDriver1: false, // 是否显示公司司机 选择弹出框
        tempCarDriver2: "", // 默认的副司机名称
        tempCarTel2: "", // 默认的副司机电话
        tempCarDriver2ID: null, // 默认的副司机GID
        isCompDriver2: false, // 是否显示公司副司机 选择弹出框
        VehicleGID: "", // 车辆的GID
      });
    },
    // 公司车辆查询
    onCompVehicleQuery() {
      let params = {
        _CompGID: this.CompGID,
        CompGID: this.CompGID,
      };
      this.$http
        .post(this.$api.onCompVehicleQuery, this.$qs.stringify(params))
        .then((res) => {
          //console.log(res)
          if (res.success) {
            this.carArr.forEach((item) => {
              item.CompVehicleArr = [...res.data];
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    // 公司司机查询
    onCompDriverQuery() {
      let params = {
        _CompGID: this.CompGID,
        CompGID: this.CompGID,
      };
      this.$http
        .post(this.$api.onCompDriverQuery, this.$qs.stringify(params))
        .then((res) => {
          // console.log(res)
          if (res.success) {
            this.carArr.forEach((item) => {
              item.CompDriverArr = [...res.data];
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    // 车辆资质查询
    onConwinVehicleQuery(obj, curIndex) {
      this.carArr[curIndex].tempCheck = "车辆验证中...";
      let params = {
        VehicleNo: obj.VehicleNo,
        VehicleNoColor: obj.CodeName,
        GPSTypeCode: "GDShengTing",
        QueryTypeList: "Qualifications",
        _CompGID: this.CompGID,
      };
      this.$http
        .post(this.$api.onConwinVehicleQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.data) {
            if (res.data.Qualifications.success) {
              this.carArr[curIndex].tempCheck = "车辆验证通过";
              if (res.data.ConwinAPIIsError == "1") {
                this.carArr[curIndex].tempCheck =
                  "省厅接口异常，但可继续派车或签到";
              }
              this.carArr[curIndex].tempCheckFlag = true;
              this.carArr[curIndex].Qualifications =
                res.data.Qualifications.data;
              this.$forceUpdate();
            } else {
              this.carArr[curIndex].tempCheck = res.data.Qualifications.msg;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 线路选中事件
    lineSelectClick(item) {
      if (!item.selectState) {
        // 没有选中线路时 -- 要选中线路
        this.lineSelectList.forEach((item) => {
          item.selectState = false;
        });
        item.selectState = true; // 用于判断线路弹出层样式
        this.LineGIDList = item.LineGID;
        this.selectedSearchLine = item.LineName;
        this.selectedSearchState = true; // 用于判断线路样式
      } else {
        // 选中线路时 -- 要取消选中
        item.selectState = false; // 用于判断线路弹出层样式
        this.selectedSearchLine = "线路";
        this.LineGIDList = "";
        this.selectedSearchState = false; // 用于判断线路样式
      }
      this.lineSelectListShow = false;
      this.getLineClassDay();
    },
    // 车辆选中事件
    carSelectClick(item) {
      if (!item.selectState) {
        // 没有选中车辆时 -- 要选中车辆
        this.OrganizationList.forEach((item) => {
          item.selectState = false;
        });
        item.selectState = true; // 用于判断车辆弹出层样式
        this.OrganizationGID = item.GID;
        this.selectedSearchCar = item.PathName;
        this.selectedSearchCarState = true; // 用于判断车辆样式
      } else {
        // 选中车辆时 -- 要取消选中
        item.selectState = false; // 用于判断车辆弹出层样式
        this.selectedSearchCar = "机构";
        this.OrganizationGID = "";
        this.selectedSearchCarState = false; // 用于判断车辆样式
      }
      this.carSelectListShow = false;
      this.getLineClassDay();
    },
    // 是否发车选中事件
    departSelectClick(item) {
      if (!item.selectState) {
        this.departStateList.forEach((item) => {
          item.selectState = false;
        });
        item.selectState = true; // 用于判断车辆弹出层样式
        this.selectedSearchDepart = item.text;
        this.selectedSearchDepartState = true; // 用于判断车辆样式
      } else {
        item.selectState = false; // 用于判断车辆弹出层样式
        this.selectedSearchDepart = "是否发车";
        this.selectedSearchDepartState = false; // 用于判断车辆样式
      }
      this.departSelectListShow = false;
      if (this.selectedSearchDepart !== "是否发车") {
        var list = this.orgLineClassList.filter((item1) => {
          if (item.text === "已发车") {
            return item1.DepartCount > 0;
          }
          return item1.DepartCount == 0;
        });
        this.lineClassList = list;
      } else {
        this.lineClassList = this.orgLineClassList;
      }
    },

    // 点击线路 -- 跳转至详情页面
    lineClassListClick(item) {
      this.setStorageLine(item);
      if (window.sessionStorage) {
        window.sessionStorage.setItem("LineClassDayGID", item.GID);
        window.sessionStorage.setItem("sendCarTime", item.sendCarTime);
        window.sessionStorage.setItem("LineName", item.LineName);
      }
      let params = {
        LineClassDayGID: item.GID,
        sendCarTime: item.sendCarTime,
        LineGID: item.LineGID,
        LineName: item.LineName,
      };
      this.$router.push({
        name: "LineClassListDetail",
        // params: params,
        query: params,
      });
    },
    //选中派车车辆
    choiceComCar(i, index) {
      this.carArr[index].tempCarNo = i.VehicleNo;
      this.carArr[index].isCompCarNo = false;
      this.carArr[index].VehicleGID = i.VehicleGID;
      this.onConwinVehicleQuery(i, index);
    },
    // 班次时间
    getClassTime(val) {
      // 输入0800，补齐中间的冒号
      if (val.length == 4 && !isNaN(val)) {
        // 4位长度，且是数字
        let hour = val.substring(0, 2);
        let min = val.substring(2, 4);
        // 合法时间校验
        if (Number(hour) > 23 || Number(min) > 60) {
          return;
        }
        return "".concat(hour, ":", min);
      }
      return val;
    },
    onOpenClassChange(e) {
      this.openClassActiveName = e;
    },
    /**
     * 设置页面数据
     */
    resetData() {
      // 页面被激活时触发，需要重新初始化curClassDate获取当天的数据
      this.curClassDate = new Date();
      if (this.$utils.getSysParams("MobileEndCanManage") === "1") {
        this.isCanManage = true;
      }
      if (this.$utils.getSysParams("IsShowLineNode") === "1") {
        this.IsShowLineNode = true;
      }
      //是否显示调度备注
      if (this.$utils.getSysParams("IsShowDispatchRemark") === "1") {
        this.IsShowDispatchRemark = true;
      }
      this.getLineClassDay();
      this.getCompLine();
      this.getOrganization();
    },
    showStateChange(classDay) {
      this.currentLineClassDay = classDay;
      this.stateChangeShow = true;
    },
    onStateChangeSelect(action, index) {
      console.log(action, this.currentLineClassDay);
      this.$dialog
        .confirm({
          title: "提醒",
          message: "是否修改班次状态为" + action.name + "？",
        })
        .then(() => {
          this.changeClassStateBtnClick(
            this.currentLineClassDay,
            action.status
          );
          this.currentLineClassDay = null;
        });
    },
  },
  watch: {
    // 监听班次数组
    lineClassList(val, prevVal) {
      // var sourceDate = new Date();
      // var index1 = val.findIndex(
      //   (item) =>
      //     new Date(item.ClassDate.replace("00:00:00.000", item.ClassTime)) >
      //     sourceDate
      // );
      // if (prevVal.length < val.length) {
      //   setTimeout(() => {
      //     var container = document.querySelectorAll(".LineClassDayList")[0];
      //     var height = 0;
      //     var wrapArr = container.querySelectorAll(".wrap");
      //     for (let i = 0; i < wrapArr.length; i++) {
      //       height += wrapArr[i].offsetHeight;
      //       if (i >= index1) {
      //         break;
      //       }
      //     }
      //     container.scrollTop = height;
      //   }, 1000);
      // }
    },
    // 复制班次的班次日期
    copyDateTime(val, prevVal) {
      let date = this.$moment(val).format("YYYY-MM-DD");
      this.copyClassDay = date;
      this.prevCopyClassDay = prevVal;
    },
    // 监听派车数组
    carArr: {
      //val, oldVal
      handler() {},
      deep: true,
    },
    // 复制班次时间
    copyClassTime(val) {
      // if (val.length == 3 && !isNaN(val)) { // 最前面补齐一个0，用于后面添加冒号
      //   val = '0' + val;
      // }

      this.copyClassTime = this.getClassTime(val);
    },
    curModifyItem: {
      deep: true,
      handler(val) {
        this.curModifyItem.ClassTime = this.getClassTime(val.ClassTime);
      },
    },
    collapseModel(val) {
      if (val) {
        this.activeNames = this.getTabLineList.map((l) => l.GID);
      } else {
        this.activeNames = [];
      }
    },
    curClassDate(val) {
      //dataCompleteState
      // if (this.dataCompleteState) {
      //   this.getCompLine();
      //   this.getLineClassDay();
      // } else {
      //   this.$toast("请勿过于频繁操作");
      // }
      this.getCompLine();
      this.getLineClassDay();
    },
  },
  created() {
    this.resetData();
    //this.scroll = new Bscroll(this.$refs.wrapper);
  },
  // 被 keep-alive 缓存的组件激活时调用。
  activated() {
    this.$refs["wrapper"].scrollTop = this.scrollTop;
    if (this.isRefresh == true) {
      this.resetData();
    }
    this.isRefresh = false;
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    // 扬扬出行楼巴细节调整 第五点 2022-10-28
    // 目前只有修改票价和派车在该页面跳转，如有添加新跳转页面需要按需添加

    // 默认缓存，返回首页后标记为需要更新数据
    if (to.path == "/") {
      this.isRefresh = true;
      // 页面被缓存，SelectDate组件的值需要重新初始化
      this.$refs.selectDateRef.selectDateIndex = 0;
      this.$refs.selectDateRef.caldendarDefaultDate = new Date();
      this.$refs.selectDateRef.dateList = [];
      this.$refs.selectDateRef.generateDateList(new Date());
    }
    let list = this.$refs["wrapper"];
    this.scrollTop = list.scrollTop || 0;
    next();

    // if (to.name == 'LineClassDayPrice' || to.name == 'LineClassDayVehicleDriver') { // 需要缓存的路由name
    //   from.meta.keepAlive = true
    //   let list = this.$refs['wrapper'];
    //   this.scrollTop = list.scrollTop || 0;
    //   next()
    // } else {
    //   from.meta.keepAlive = false
    //   next()
    // }
  },
};
</script>

<style>

.single-line-ellipsis {
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden;    /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */

  width: 100%;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;
      border-bottom: 1px solid #eee;
}

.lineTitle {
  text-align: left;
  padding: 0.2rem;
  font-size: 16px;
  background-color: orange;
  color: white;
  border-radius: 5px;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
</style>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}

/deep/.lineSelect {
  margin-bottom: 0.3rem;

  > .van-cell {
    // background-color: #ffa500;
    border-radius: 0.15625rem;
    // color: white;
    text-align: left;
    font-size: 16px;
    box-shadow: 2px 2px 10px #ccc;
  }
}

/deep/.van-collapse-item__content {
  padding: 0rem;
}

.LineClassList {
  width: 100%;
  height: auto;

  .date-content {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    color: #2891e7;
    background-color: #fff;
    font-size: 0.4rem;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0.2rem;
    position: fixed;
    top: 1.40625rem;
    z-index: 2;

    .left .icon {
      font-size: 0.32rem;
      margin-right: 0.1rem;
      position: relative;
      font-weight: bold;
    }

    .date .icon {
      font-size: 0.4rem;
      position: relative;
      right: 0.1rem;
    }

    .right .icon {
      font-size: 0.32rem;
      margin-left: 0.1rem;
      position: relative;
      font-weight: bold;
    }
  }

  .LineClassDayList {
    width: 100%;
    // height: calc(100vh - 4rem);
    color: #666;
    font-weight: 700;
    // padding: 0 0.4rem;
    box-sizing: border-box;
    overflow: scroll;
    // position: absolute;
    top: 2.70625rem;
    left: 0;
    right: 0;
    bottom: 1rem;

    & /deep/ .van-tabs--line {
      margin-bottom: 15px;
    }

    > div {
      > .wrap {
        width: 100%;
        height: auto;
        font-size: 0.32rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;

        // margin-top: 0.5rem;
        > .lineName {
          height: 1rem;
          line-height: 1rem;
          background-color: #999;
          color: #fff;
          box-sizing: border-box;
          padding: 0 0.2rem;
        }

        > .btnWrap {
          width: 100%;
          height: auto;
          text-align: center;
          display: flex;
          justify-content: space-between;

          > span {
            flex: 1;
            background-color: #2891e7;
            color: #fff;
            text-align: center;
            padding: 0 0;
          }
        }

        > div {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-between;

          > span,
          > div {
            flex: 1;
            height: auto;
            line-height: 1rem;
            border: 1px solid #ccc;
            box-sizing: border-box;
            padding: 0 0.2rem;
            text-align: left;

            > span {
              color: #2891e7;
            }

            > span.currentState {
              color: red;
            }
          }

          > span:nth-child(2) {
            border-left: 0;
          }
        }
      }
    }
  }

  footer {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 0.44rem;
    background-color: #999;
    color: #fff;

    div {
      width: 50%;
      height: auto;
    }

    div:nth-child(2),
    div:nth-child(3) {
      border-left: 1px solid #fff;
    }

    div.current {
      background-color: #555562;
    }
  }

  .classState {
    width: 100%;
    height: auto;

    > div {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;
    }

    > div:first-child {
      border-bottom: 0.02rem solid #ccc;
    }
  }

  .isCopyClass {
    width: 80%;
    height: auto;
    font-size: 0.4rem;

    .header {
      width: 100%;
      height: 1.4rem;
      line-height: 1.4rem;
      background-color: #2891e7;
      color: #fff;
      padding: 0 0.2rem;
      box-sizing: border-box;
    }

    > div {
      width: 100%;
      height: 1.4rem;
      line-height: 1.4rem;
      display: flex;
      justify-content: space-between;
      border-bottom: 0.02rem solid #ccc;
      padding: 0 0.2rem;
      box-sizing: border-box;

      span {
        input {
          height: 0.8rem;
          border: 0.02rem solid #ccc;
          padding: 0 0.2rem;
          box-sizing: border-box;
        }
      }

      span:nth-child(1) {
        // display: inline-block;
        // width: 2rem;
        flex: 1;
      }

      // span:nth-child(2) {
      //   flex: 1;
      // }
    }

    > .btnWrap {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-around;
      padding: 0;

      span {
        flex: 1;
        height: 1rem;
        line-height: 1rem;
      }

      span:nth-child(1) {
        background-color: #2891e7;
        color: #fff;
      }

      span:nth-child(2) {
        background-color: #999;
        color: #fff;
      }
    }
  }

  .isModifyClass {
    width: 80%;
    height: auto;
    font-size: 0.4rem;

    .header {
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      background-color: #2891e7;
      color: #fff;
      padding: 0 0.2rem;
      box-sizing: border-box;
    }

    > .wrap {
      width: 100%;
      height: 60vh;
      overflow: scroll;

      > div {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.02rem solid #ccc;
        padding: 0 0.2rem;
        box-sizing: border-box;

        span {
          width: 100%;
          height: 1.2rem;
          line-height: 1.2rem;
          text-align: left;

          input {
            width: 100%;
            height: 0.8rem;
            border: 0.02rem solid #ccc;
            padding: 0 0.2rem;
            box-sizing: border-box;
            z-index: 1;
          }
        }

        span:nth-child(1) {
          width: 3rem;
        }

        span:nth-child(2) {
          flex: 1;
          text-align: right;
        }
      }
    }

    .btnWrap {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      z-index: 2;
      transform: translateY(0.02rem);

      > div {
        width: 50%;
        height: 1rem;
        line-height: 1rem;
      }

      > div:nth-child(1) {
        background-color: #2891e7;
        color: #fff;
      }

      > div:nth-child(2) {
        background-color: #999;
        color: #fff;
      }
    }
  }

  > .isSendCarAndSignIn {
    width: 100%;
    height: auto;

    > div {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      span {
        height: 1rem;
        line-height: 1rem;
        font-size: 0.4rem;
        border-bottom: 0.02rem solid #ccc;
      }
    }
  }

  > .isSendCar {
    width: 80%;
    height: auto;
    font-size: 0.4rem;

    > div {
      width: 100%;
      height: 10rem;
      overflow: scroll;

      > div {
        width: 100%;
        height: auto;
        margin-bottom: 0.4rem;

        > .header {
          width: 100%;
          height: 1rem;
          line-height: 1rem;
          background-color: #999;
          color: #fff;
        }

        > .wrap {
          width: 100%;
          height: auto;

          .row {
            width: 100%;
            height: 1rem;
            line-height: 1rem;
            display: flex;
            justify-content: space-between;
            padding: 0 0.2rem;
            box-sizing: border-box;
            margin-top: 0.2rem;

            > span {
              width: 5rem;
              text-align: left;
            }

            > input {
              flex: 1;
              border: 0.02rem solid #ccc;
              height: 0.8rem;
              margin-top: 0.1rem;
              box-sizing: border-box;
              text-align: center;
            }
          }
        }
      }

      .btn {
        width: 100%;
        height: auto;
        margin: 0.2rem 0;
        display: flex;
        justify-content: space-around;

        span:first-child {
          width: 2rem;
        }

        span {
          width: 1rem;
          height: 0.6rem;
          line-height: 0.6rem;
          background-color: #2891e7;
          color: #fff;
          padding: 0.2rem;
          border-radius: 0.1rem;
        }
      }
    }
  }

  .isComp {
    width: 100%;
    height: 6.5rem;

    > .header {
      background-color: #999;
      color: #fff;
    }

    > div {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;
      border-bottom: 0.02rem solid #ccc;
    }
  }

  .lineSelectListPopup {
    width: 100%;
    height: 60vh;

    .lineSelectList {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;
      border-bottom: 1px solid #eee;
    }

    .lineSelectList.current {
      background-color: #2891e7;
      color: #fff;
    }
  }
}

.stopSale {
  display: inline-block;
  padding: 0 0.2rem;
  background: #f30;
  margin-left: 0.1rem;

  span {
    font-size: 0.4rem;
    color: #fff;
  }
}
</style>
<style>
.weekday {
  color: red;
  font-weight: bold;
}
</style>
